import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Signature from "@/components/site/Signature";
import Reviews from "@/components/site/Reviews";
import MenuSection from "@/components/site/MenuSection";
import Gallery from "@/components/site/Gallery";
import Visit from "@/components/site/Visit";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    document.title = "Cafe Anh — Vietnamese Coffee Shop in Helsinki";
  }, []);

  return (
    <div className="App min-h-screen bg-[#F4F0EA] text-[#132A1C]">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#132A1C",
            color: "#F4F0EA",
            border: "1px solid rgba(244,240,234,0.15)",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "0.02em",
          },
        }}
      />
      <Nav />
      <main>
        <Hero />
        <About />
        <Signature />
        <MenuSection />
        <Reviews />
        <Gallery />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}

export default App;
